// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var CrossRateCalculationType;
(function (CrossRateCalculationType) {
    CrossRateCalculationType[CrossRateCalculationType["BID"] = 0] = "BID";
    CrossRateCalculationType[CrossRateCalculationType["ASK"] = 1] = "ASK";
    CrossRateCalculationType[CrossRateCalculationType["BID_ASK_2"] = 2] = "BID_ASK_2";
})(CrossRateCalculationType || (CrossRateCalculationType = {}));
export var CrossRateType;
(function (CrossRateType) {
    CrossRateType[CrossRateType["Simple"] = 0] = "Simple";
    CrossRateType[CrossRateType["Reverse"] = 1] = "Reverse";
})(CrossRateType || (CrossRateType = {}));
